module.exports = __webpack_public_path__ + "public/images/2023_Evergreen_FacebookPost.5797d102b1006150e0ccbf304a559082.jpg";